import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import jQuery from "jquery";
import $ from "jquery";

import "round-slider";
import { ActionSheetController } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { filter, map } from "rxjs/operators";
import { Building } from "src/components/shared-components/class/general-classes/building";
import { Environment } from "src/components/shared-components/class/general-classes/environment";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { Supervision } from "src/model/class/general classes/supervision";
import { ActionListBuilding } from "src/model/enum/enumActionSheetOperation";
import {
  BACSCoefficient,
  EnergyCoefficient,
  UsersRole,
} from "src/model/enum/enumDigitalPlace";
import { ApplicationTheme } from "src/components/shared-components/enum/enumMisc";
import { iTranslation } from "src/components/shared-components/interfaces/iTranslation";
import { AlertService } from "src/service/alert.service";
import { DpBuildingService } from "src/service/building.service";
import { EnvironmentService } from "src/service/environment.service";
import { EventService } from "src/service/event.service";
import { NetworkService } from "src/service/network.service";
import { PlantService } from "src/service/plant.service";
import { SupervisionService } from "src/service/supervision.service";
import { SystemRouterService } from "src/service/system-router.service";
import { ThemeService } from "src/service/theme.service";
import { currentBuildingChangeSelectionAction } from "src/components/shared-components/state/actions/building.action";

@Component({
    selector: "app-circular-slider",
    templateUrl: "./circular-slider.component.html",
    styleUrls: ["./circular-slider.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CircularSliderComponent {
  private _sliderInstance: any = null;
  private _previousValue: number = 0;
  constructor(private el: ElementRef, private _alertService: AlertService) { }

  ngOnInit() {
    this.initializeSlider();
  }

  ngOnDestroy() { }

  /**
   * Initialize slider
   */
  private initializeSlider() {
    this._sliderInstance = jQuery(this.el.nativeElement)
      .find("#gauge")
      .roundSlider({
        radius: 110,
        circleShape: "pie",
        width: 45,
        startAngle: "315",
        handleShape: "round",
        handleSize: 43,
        borderColor: "blue",
        borderWidth: 10,
        startValue: 0,
        value: 0,
        showTooltip: false,
        editableTooltip: false,
        tooltipFormat: function (e) {
          return e.value;
        },
      });

    setInterval(() => {
      const currentValue = $("#gauge").roundSlider("getValue");
      if (currentValue !== this._previousValue) {
        //Value is changed
        this._previousValue = currentValue;
      }
    }, 500);

    const rsTooltipElement = document.querySelector(
      ".rs-inner"
    ) as HTMLSpanElement;

    /*const newDivHTML =
      '<div class="rs-tooltip rs-tooltip-text"><img src="../../../assets/img/smartComponent/imgLight.png" style="display:block;margin:0 auto;width:80px"></div>';

    rsTooltipElement.innerHTML += newDivHTML;
    while (rsTooltipElement.firstChild) {
      rsTooltipElement.removeChild(rsTooltipElement.firstChild);
    }
    const imageElement = document.createElement("img");
    imageElement.src = "../../../assets/img/smartComponent/imgLight.png"; 
    imageElement.style.display = "block";
    imageElement.style.margin = "0 auto";
    imageElement.style.width = "80px";
    rsTooltipElement.appendChild(imageElement);*/
  }
}
